<div class="login">
    <main [ngClass]="{'bg-dark': loading}" class="container-fluid d-flex flex-column pb-5 pb-md-0 align-items-center h-100">
        <div class="overlay" *ngIf="loading">
            <div class="d-flex align-items-center justify-content-center">
                <div class="spinner-border text-primary" role="status">
                   
                </div>
            </div>
        </div>
        <section class="container-md bg-light m-auto p-lg-5" *ngIf="!loading">
          <div class="row d-flex align-items-center justify-content-center">
        
            <!-- Formulario -->
            <div class="col-12 col-lg-4 mb-4 mb-lg-0">
              <div class="card border-0 sign-in__shadow-card h-100 rounded-3">
                <div class="card-body justify-content-center mb-2">
                  <div class="animation-form my-auto">
        
                    <form *ngIf="!showFormUser" [formGroup]="loginForm" class="main-panel__form">
        
                      <div class="text-center text-md-center mt-md-0 img-login px-4 pb-3 px-lg-2 px-md-5">
                        <img src="assets/img/Digital-Ware.png" alt="Logo" class="logo"/>
                      </div>
        
                      <div class="form__group px-3" [class.disabled-block]="autenticationADpassword === 'S'">
                        <label for="" class="form__label">Nombre de usuario</label>
                        <input formControlName="usuario" id="usuario" type="email" class="form__input"
                               [ngClass]="{'alert alert-danger': loginForm.get('usuario')?.touched && loginForm.get('usuario')?.invalid}"
                               placeholder="Nombre de usuario"
                               [class.is-invalid]="usuario?.invalid && usuario?.touched" required/>
                        <div *ngIf="(usuario?.invalid && usuario?.touched) || usuario?.dirty">
                          <small *ngIf="usuario?.errors?.required" class="invalid-feedback">Por favor, ingrese su usuario</small>
                        </div>
                      </div>
        
                      <div class="form__group mb-3 px-3" [class.disabled-block]="autenticationADpassword === 'S'">
                        <label for="" class="form__label">Contraseña:</label>
                        <input formControlName="password" id="password" [type]="showPassword ? 'text' : 'password'" class="form__input"
                               placeholder="Ingresa tu contraseña"
                               [ngClass]="{'alert alert-danger': loginForm.get('password')?.touched && loginForm.get('password')?.invalid}"
                               [class.is-invalid]="password?.invalid && password?.touched" required/>
                        <div *ngIf="(password?.invalid && password?.touched) || password?.dirty">
                          <small *ngIf="password?.errors?.required" class="invalid-feedback">Por favor, ingrese su contraseña</small>
                        </div>
                        <span (click)="showPassword = !showPassword" class="form__icon fa-solid"
                              [ngClass]="showPassword ? 'fa-eye' : 'fa-eye-slash'"></span>
                      </div>
        
                      <div *ngIf="(RcaptchaSeven)" class="form__group mb-3 px-3">
                        <div class="col-md-12">
                          <img [src]="image" alt="Captcha" style="width:100%;">
                        </div>
                        <input id="cap" class="form__input" placeholder="Captcha" (change)="eventcaptcha($event)" required/>
                        <span style="margin-top: 8%;" (click)="generateNew()" class="form__icon fa-solid fa-refresh"></span>
                      </div>
        
                      <div class="text--center px-3 my-4" [class.disabled-block]="autenticationADpassword === 'S'">
                        <button class="btn-principal w-100" (click)="sendLogin()">Ingresar</button>
                        <div class="d-grid py-1">
                          <span class="text-center">O</span>
                        </div>
                        <button type="button" id="prueba" (click)="rememberUser()" class="btn btn-link form__help">Recuperar Contraseña</button>
                      </div>
        
                      <div style="text-align: center;">
                        <div *ngIf="autenticacionOauth == 'S'">
                          <h4>continuar con</h4>
                          <div style="background-color:white;color:#0f993e;border-color:#0f993e;width:103px;margin-left:27%;position:relative;">
                          </div>
                          <button class="col-12 btn btn-primary"
                                  style="width: 15%;margin-top:-2%;background-color:white;color:#0072c6;border-color:#0072c6;margin-left:0%;border:1px solid black;"
                                  (click)="signIn()">
                            <img class="icon" style="height:28px;max-width:28px;width:31px !important;margin-left:-5px;"
                                 src="./assets/media/logos/Outlook_icon.png"/>
                          </button>
                        </div>
                      </div>
                    </form>
        
                    <remember-user *ngIf="showFormUser || tokenUser"
                                   [token]="tokenUser"
                                   [tokenvalidate]="tokenUser"
                                   [email]="mail"
                                   [ambiente]="ambiente?.value"
                                   (eventRemember)="listenRememberUser($event)">
                    </remember-user>
        
                  </div>
                </div>
              </div>
            </div>
        
            <!-- Carrusel -->
            <div id="carouselExampleIndicators" class="col-12 col-lg-8 carousel slide">
              <div class="carousel-indicators">
                <button *ngFor="let _ of imglogin; let i = index"
                        type="button"
                        [class.active]="i === 0"
                        [attr.data-bs-target]="'#carouselExampleIndicators'"
                        [attr.data-bs-slide-to]="i"
                        [attr.aria-label]="'Slide ' + (i + 1)">
                </button>
              </div>
            
              <div class="carousel-inner h-100">
                <div *ngFor="let img of imglogin; let i = index"
                     class="carousel-item"
                     [class.active]="i === 0">
                  <img [src]="img.imagen" alt="Slide {{ i + 1 }}">
                </div>
              </div>
            
              <button class="carousel-control-prev" type="button"
                      data-bs-target="#carouselExampleIndicators" data-bs-slide="prev" (click)="prev()">
                <i class="fa-solid fa-chevron-left fs-3"></i>
              </button>
              <button class="carousel-control-next" type="button"
                      data-bs-target="#carouselExampleIndicators" data-bs-slide="next" (click)="next()">
                <i class="fa-solid fa-chevron-right fs-3"></i>
              </button>
            </div>
            
        
          </div>
        </section>
        
    </main>
    <footer class="footer">
        <div class="row px-2 px-lg-5 flex-grow-1">
            <div class="d-flex align-items-center bd-highlight flex-wrap px-1 justify-content-around w-100">
                <div class="footer__text p-1 p-xl-3 bd-highlight align-self-center text-center"><img class="text-center mw-100r imgfooter" width=" 150" src="assets/img/loading-company.png" alt="logo kactus"></div>
                <div class="footer__text p-1 bd-highlight ">Versión {{version}}</div>
                <div class="footer__text p-1 bd-highlight">Términos y condiciones</div>
                <div class="footer__text p-1 bd-highlight">Políticas de privacidad</div>
                <div class="footer__text ms-lg-auto p-1 bd-highlight">{{ today | date:'medium' }}</div>
                <div class="footer__text ms-lg-auto p-1 bd-highlight text-center">Copyright 	&copy; 1992-{{year}} Digital Ware - Todos los derechos reservados</div>
            </div>
        </div>
    </footer>

    <dx-popup
    [(visible)]="popupVisible"
    [dragEnabled]="false"
    [closeOnOutsideClick]="true"
    [showCloseButton]="true"
    [title]="'Iniciar Sesión'"
   >
    <div *dxTemplate="let data of 'content'">
      <form [formGroup]="loginForm" class="main-panel__form">
        <div class="form__group">
          <label for="usuario" class="form__label">Nombre de usuario</label>
          <input formControlName="usuario" id="usuario" type="email" class="form__input" placeholder="Nombre de usuario" required />
          <div *ngIf="loginForm.get('usuario')?.invalid && loginForm.get('usuario')?.touched">
            <small class="invalid-feedback">Por favor, ingrese su usuario</small>
          </div>
        </div>
        <div class="form__group">
          <label for="password" class="form__label">Contraseña:</label>
          <input formControlName="password" id="password" type="password" class="form__input" placeholder="Ingresa tu contraseña" required />
          <div *ngIf="loginForm.get('password')?.invalid && loginForm.get('password')?.touched">
            <small class="invalid-feedback">Por favor, ingrese su contraseña</small>
          </div>
        </div>
        <div class="text--center">
          <button type="button" class="btn-principal" (click)="sendLogin()">Ingresar</button>
          <button type="button" class="btn-principal" (click)="sendLogin()">Iniciar Azure AD</button>
        </div>
      </form>
    </div>
  </dx-popup>

  <dx-popup
  [(visible)]="popupVisible2sfGoogle"
  [dragEnabled]="false"
  [closeOnOutsideClick]="true"
  [showCloseButton]="true"
  [title]="'Iniciar Sesión'"
  [width]="800" [height]="725"
>
  <ng-template #titleTemplate>
    <div style="text-align: center; font-weight: bold; color: #003366;">Iniciar Sesión</div>
  </ng-template>
  <div class="container text-center">
    <h2 style="color: #003366;">Autenticación en dos pasos</h2>
    <div *ngIf="qrCodeUri" class="mb-4">
      <h2 style="color: #003366;">Escanea este código QR con  Authenticator</h2>
      <div style="display: flex; justify-content: center;">
        <qrcode [qrdata]="qrCodeUri" [width]="256"></qrcode>
      </div>
    </div>

    <div>
      <label for="code" style="color: #003366; font-size: 18px;">Introduce el código de 6 dígitos de Authenticator:</label>
    </div>
    <div> 
      <input id="code" [(ngModel)]="code" type="text" maxlength="6" pattern="[0-9]*" inputmode="numeric" style="margin-top: 8px; padding: 5px; font-size: 14px; width: 45%;" />
    </div>
    <div style="margin-top: 16px;">
      <button 
        #validateButton
        (click)="onValidate()" 
        style="background-color: #003366; color: white; border: none; padding: 12px 24px; cursor: pointer; border-radius: 5px; font-size: 16px;"
        (mouseover)="validateButton.style.backgroundColor='#f8bd1f'; validateButton.style.color='white';"
        (mouseout)="validateButton.style.backgroundColor='#003366'; validateButton.style.color='white';"
      >
        Validar
      </button>
    </div>

    <div *ngIf="message" [ngClass]="{'text-success': messageStyle === 'success', 'text-error': messageStyle === 'error'}">
      <p>{{ message }}</p>
    </div>
  </div>
</dx-popup>
</div>


<dx-popup
  [(visible)]="popuplicen"
  [showCloseButton]="false"
  [showTitle]="true"
  [dragEnabled]="false"
  [closeOnOutsideClick]="false"
  [width]="900"
  [height]="600"
  [position]="{ my: 'center', at: 'center', of: 'window' }"
  title="Aceptación de Licencia">

  <!-- Contenido con scroll -->
  <div class="p-3" style="max-height: 420px; overflow-y: auto; text-align: justify;">
    <p>
      COMPONENTE REVISIÓN AUTOMÁTICO DE LICENCIAMIENTO  
      El objetivo del componente de revisión de licenciamiento es consultar el licenciamiento sobre el que está haciendo uso EL 
      CLIENTE contra el licenciamiento legalizado del software ante DIGITAL WARE S.A.S.  
      <br><br>
      Este componente se encontrará instalado en los equipos del CLIENTE y se encargará de consultar la información del 
      licenciamiento del que está haciendo uso para determinar si existe o no un licenciamiento excedido. Además, también se 
      encargará de consultar la versión del sistema que se encuentra instalada en los equipos del CLIENTE.
      <br><br>
      El componente se ejecutará automáticamente y se encargará de enviar, por medio de correo electrónico, el reporte de la 
      información del licenciamiento usado por EL CLIENTE a DIGITAL WARE S.A.S. Dicho reporte de información solo contendrá el 
      número de licencias que está usando EL CLIENTE y el número de licencias que tiene debidamente legalizadas ante DIGITAL 
      WARE S.A.S.
      <br><br>
      La instalación del componente se entiende autorizada por EL CLIENTE con la ejecución de la misma instalación, ya que esta 
      actividad será realizada directamente por su personal.
      <br><br>
      PROTECCIÓN DE DATOS PERSONALES
      <br><br>
      Si bien DIGITAL WARE S.A.S no tendrá acceso a la Base de Datos del CLIENTE en la ejecución del componente automático 
de revisión de licenciamiento, toda vez que, el componente será ejecutado e instalado directamente por el personal del 
CLIENTE, DIGITAL WARE S.A.S se compromete a cumplir con lo previsto en la Ley 1581 de 2012 y el Decreto 1377 de 2013, 
y sus normas complementarias, modificatorias o suplementarias, sobre los datos personales que por cualquier motivo llegue a 
<br><br>
conocer en virtud del reporte de la información del licenciamiento.    
<br><br>
USO DE CORREO ELECTRÓNICO Y PROCESAMIENTO DEL REPORTE DE LICENCIAMIENTO
<br><br>
EL CLIENTE con la instalación del componente automático de revisión de licenciamiento, autoriza el uso de correo electrónico u otro medio electrónico para transmitir el Reporte de Licenciamiento.
</p>
  </div>

  <!-- Footer fijo -->
  <div class="p-3 border-top">
    <div class="form-check">
      <input type="checkbox" class="form-check-input" id="chkLicense"
             [(ngModel)]="accepted" />
      <label class="form-check-label" for="chkLicense">
        He leído y acepto la licencia
      </label>
    </div>

    <div class="text-end mt-3">
      <button class="btn btn-secondary me-2" (click)="onCancel()">Cancelar</button>
      <button class="btn btn-primary" [disabled]="!accepted" (click)="onAccept()">Aceptar</button>
    </div>
  </div>
</dx-popup>



